<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="companyManagementData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations">
        <span @click="doDelete(index)">
          <Button type="error" size="small" @click="companyDelmodal = true">{{
            $t("common.del")
          }}</Button>
        </span>
      </template>
      <template slot-scope="{ row, index }" slot="active">
        <p v-if="row.vipIsActive">是</p>
        <p v-else>否</p>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除 -->
    <Modal v-model="companyDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ companyName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeCompany()"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="companyEditModal"
      title="编辑公司"
      :loading="loading"
      @on-ok="companySubmit('companyEditForm')"
      @on-cancel="companyReset('companyEditForm')"
      :mask-closable="false"
    >
      <Form
        ref="companyEditForm"
        :model="companyEditForm"
        :label-width="140"
        :rules="ruleValidate"
      >
        <!-- 公司名称 -->
        <FormItem label="公司名称" prop="companyName">
          <Input
            v-model="companyEditForm.companyName"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 公司地址 -->
        <FormItem label="公司地址" prop="companyAddress">
          <Input
            v-model="companyEditForm.companyAddress"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 母公司名称 -->
        <FormItem label="母公司名称" prop="parentCompany">
          <Input
            v-model="companyEditForm.parentCompany"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 账单邮寄地址 -->
        <FormItem label="账单邮寄地址" prop="companyBillAddress">
          <Input
            v-model="companyEditForm.companyBillAddress"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 客户类型 -->
        <FormItem label="客户类型" prop="customerType">
          <Select v-model="companyEditForm.customerType" style="width:300px;">
            <Option
              :value="item.id"
              v-for="item in customerTypeList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 激活码 -->
        <FormItem :label="$t('message.ActivationCode')">
          <Input
            v-model="companyEditForm.activeCode"
            style="width:205px"
            disabled
          ></Input>
          <Button
            v-if="!companyEditForm.activeCode"
            type="primary"
            @click="handleGetactiveCode"
            >{{ $t("message.getActivationCode") }}</Button
          >
        </FormItem>
        <!-- 激活时长 -->
        <FormItem :label="$t('message.ActivationType')">
          <DatePicker
            type="datetime"
            :options="options"
            v-model="companyEditForm.vipEndTime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择日期"
            style="width:300px;"
          ></DatePicker>
        </FormItem>
        <!-- 邮件通知回复案例 -->
        <FormItem label="邮件通知回复案例" prop="replySwitch">
          <RadioGroup v-model="companyEditForm.replySwitch">
            <Radio
              v-for="list in replySwitchList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 监控AWS健康仪表盘 -->
        <FormItem label="监控AWS健康仪表盘" prop="monitorAwsHealthDashboard">
          <RadioGroup v-model="companyEditForm.monitorAwsHealthDashboard">
            <Radio
              v-for="list in monitorAwsHealthDashboardList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

let tableCompanyManagementVue = {};
export default {
  name: "TableCompanyManagement",
  components: {
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      isShowOperationLog: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyDelmodal: false,
      companyEditModal: false,
      companyName: "",
      val: "",
      modal_loading: false,
      loading: true,
      customerTypeVal: "",
      customerTypeList: [],
      replySwitchList: [
        {
          id: 0,
          label: "true",
          name: this.$t("common.yes")
        },
        {
          id: 1,
          label: "false",
          name: this.$t("common.no")
        }
      ],
      monitorAwsHealthDashboardList: [
        {
          id: 0,
          label: "true",
          name: this.$t("common.yes")
        },
        {
          id: 1,
          label: "false",
          name: this.$t("common.no")
        }
      ],
      companyEditForm: {
        companyName: "",
        companyAddress: "",
        parentCompany: "",
        companyBillAddress: "",
        replySwitch: "true",
        monitorAwsHealthDashboard: "true",
        customerType: "",
        activeCode: "",
        vipEndTime: ""
      },
      columns: [
        {
          title: this.$t("companyManagement.companyName"),
          key: "companyName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.companyEditModal = true; //编辑账户弹出层
                    this.companyEditForm.id = params.row.id;
                    // 公司名称
                    this.companyEditForm.companyName = params.row.companyName;
                    // 公司地址
                    this.companyEditForm.companyAddress =
                      params.row.companyAddress;
                    // 母公司名称
                    this.companyEditForm.parentCompany =
                      params.row.parentCompany;
                    // 账单邮寄地址
                    this.companyEditForm.companyBillAddress =
                      params.row.companyBillAddress;
                    // 客户类型
                    this.companyEditForm.customerType = params.row.customerType;
                    // 对接时需更改
                    // 激活码
                    this.companyEditForm.activeCode = !!params.row.activeCode
                      ? params.row.activeCode
                      : "";
                    // 激活时长
                    this.companyEditForm.vipEndTime = params.row.vipEndTimeString;
                    // 邮件通知回复案例
                    if (params.row.replySwitch == this.$t("common.yes")) {
                      this.companyEditForm.replySwitch = "true";
                    } else if (params.row.replySwitch == this.$t("common.no")) {
                      this.companyEditForm.replySwitch = "false";
                    }
                    // 监控AWS健康仪表盘
                    if (
                      params.row.awsServiceStateMonitor == this.$t("common.yes")
                    ) {
                      this.companyEditForm.monitorAwsHealthDashboard = "true";
                    } else if (
                      params.row.awsServiceStateMonitor == this.$t("common.no")
                    ) {
                      this.companyEditForm.monitorAwsHealthDashboard = "false";
                    }
                  }
                }
              },
              params.row.companyName
            );
          }
        },
        {
          title: this.$t("companyManagement.companyAddress"),
          key: "companyAddress"
        },
        {
          title: this.$t("companyManagement.parentCompanyName"),
          key: "parentCompany"
        },
        {
          title: this.$t("companyManagement.emailNotificationReply"),
          key: "replySwitch"
        },
        {
          title: this.$t("companyManagement.AWSHealthMonitorDashboard"),
          key: "awsServiceStateMonitor"
        },
        {
          title: this.$t("companyManagement.billingAddress"),
          key: "companyBillAddress"
        },
        {
          title: this.$t("companyManagement.customerType"),
          key: "customerTypeName"
        },
        {
          title: this.$t("message.ActiveorNot"),
          key: "vipIsActive",
          slot: "active"
        },
        {
          title: this.$t("message.ExpiryDate"),
          key: "vipEndTimeString"
        },
        {
          title: this.$t("companyManagement.operation"),
          width: 200,
          slot: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.logClick(params.row, params.index);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "permissionsConfigurationManagement:companyManagement:log"
                      )
                    }
                  ]
                },
                "操作日志"
              ),
              // h('i-switch', {
              //     props: {
              //         type: 'primary',
              //         size: 'large',
              //         value: params.row.isActive
              //     },
              //     style: {
              //         'margin-right': '5px'
              //     },
              //     on: {
              //         'on-change': () => {
              //             this.switch(params.index)
              //         }
              //     }
              // }, [
              //     h('span', {
              //         slot: 'open',
              //         domProps: {
              //             innerHTML: this.$t('alarms.common.enable')
              //         }
              //     }),
              //     h('span', {
              //         slot: 'close',
              //         domProps: {
              //             innerHTML: this.$t('alarms.common.disable')
              //         }
              //     })
              // ])

              h(
                "i-switch",
                {
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.vipIsActive
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("message.Expiry")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("message.close")
                    }
                  })
                ]
              )
              //  ,h('Button', {
              //       props: {
              //           type: 'error',
              //           size: 'small'
              //       },
              //       on: {
              //           'click': () => {
              //               this.doDelete(params.index)
              //               this.companyDelmodal = true
              //           }
              //       }
              //   }, '删除')
            ]);
          }
        }
      ],
      ruleValidate: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            type: "string",
            message: "公司名称为1-100个字符",
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        companyAddress: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          {
            type: "string",
            message: "公司地址为1-100个字符",
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        parentCompany: [
          { required: true, message: "请输入母公司地址", trigger: "blur" },
          {
            type: "string",
            message: "母公司地址为1-100个字符",
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        companyBillAddress: [
          { required: true, message: "请输入账单邮寄地址", trigger: "blur" },
          {
            type: "string",
            message: "账单邮寄地址为1-100个字符",
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        replySwitch: [
          {
            required: true,
            message: "请选择回复开关",
            trigger: "change",
            type: "string"
          }
        ],
        monitorAwsHealthDashboard: [
          {
            required: true,
            message: "请选择监控AWS健康仪表盘",
            trigger: "change",
            type: "string"
          }
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "change",
            type: "number"
          }
        ]
      },
      companyManagementData: []
    };
  },
  beforeCreate: function() {
    tableCompanyManagementVue = this;
  },
  mounted: function() {
    tableCompanyManagementVue.getCompanyManagementData();
    tableCompanyManagementVue.getCustomerTypeDropDownBox();
  },
  methods: {
    handleGetactiveCode() {
      // 请求接口，把拿到的数据放在激活码输入框里面，需要注意，编辑时，如果返回了激活码字段，那么点击按钮不显示
      this.$api.company.generateVipActiveCode().then(res => {
        this.companyEditForm.activeCode = res.data;
      });
    },
    // 获取客户类型下拉框
    getCustomerTypeDropDownBox: function() {
      this.customerTypeList = [];
      this.$api.company
        .getCustomerTypeDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.customerTypeList = res.data;
        });
    },
    showAll: function() {
      tableCompanyManagementVue.getCompanyManagementData();
    },
    // 分页显示数据
    getCompanyManagementData: function() {
      eventBus.$on("companyName", function(val) {
        tableCompanyManagementVue.val = val;
      });

      eventBus.$on("customerType", function(customerTypeVal) {
        tableCompanyManagementVue.customerTypeVal = customerTypeVal;
      });
      // 列表分页
      this.$api.company
        .pageCompany({
          companyName: tableCompanyManagementVue.val,
          customerType: tableCompanyManagementVue.customerTypeVal,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.companyManagementData = res.data.records;
          for (var i = 0; i < this.companyManagementData.length; i++) {
            // 邮件通知回复案例
            if (this.companyManagementData[i].replySwitch) {
              this.companyManagementData[i].replySwitch = this.$t("common.yes");
            } else {
              this.companyManagementData[i].replySwitch = this.$t("common.no");
            }
            // 监控AWS健康仪表盘
            if (this.companyManagementData[i].awsServiceStateMonitor) {
              this.companyManagementData[i].awsServiceStateMonitor = this.$t(
                "common.yes"
              );
            } else {
              this.companyManagementData[i].awsServiceStateMonitor = this.$t(
                "common.no"
              );
            }
          }
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableCompanyManagementVue.getCompanyManagementData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableCompanyManagementVue.getCompanyManagementData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyName");
      eventBus.$off("customerType");
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
      this.companyName = this.companyManagementData[index].companyName;
    },
    removeCompany: function() {
      var lineIndex = this.lineIndex;
      // 删除
      this.$api.company
        .deleteCompany("id", this.companyManagementData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableCompanyManagementVue.getCompanyManagementData();
            this.modal_loading = false;
            this.companyDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    /*****************************switch*************************/
    switch(index) {
      this.index = index;
      // 打开是true,启用0 禁用1
      if (this.companyManagementData[index].vipIsActive) {
        this.changeStatusMessage(this.companyManagementData[index].id, false);
      } else {
        this.changeStatusMessage(this.companyManagementData[index].id, true);
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, value) {
      this.$api.company.vipActiveDisable("id", id).then(res => {
        tableCompanyManagementVue.getCompanyManagementData();
      });
    },
    // 确定
    companySubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.company
            .updateCompany({
              id: this.companyEditForm.id,
              companyName: this.companyEditForm.companyName,
              companyAddress: this.companyEditForm.companyAddress,
              companyBillAddress: this.companyEditForm.companyBillAddress,
              parentCompany: this.companyEditForm.parentCompany,
              replySwitch: this.companyEditForm.replySwitch,
              awsServiceStateMonitor: this.companyEditForm
                .monitorAwsHealthDashboard,
              customerType: this.companyEditForm.customerType,
              activeCode: this.companyEditForm.activeCode,
              vipEndTime: this.companyEditForm.vipEndTime,
              activeCodeType: 0,
              activeType: 1,
              activeSource: 1,
              activeChannel: "00002"
            })
            .then(res => {
              setTimeout(() => {
                tableCompanyManagementVue.showAll();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("编辑成功");
                this.companyEditModal = false;
              }, 1000);
            });
          //延时清空数据
          setTimeout(() => {
            this.$refs[name].resetFields();
          }, 2000);
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    // 取消
    companyReset: function(name) {
      this.$refs[name].resetFields();
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          8
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/company_management/TableCompanyManagement.vue